// removed by extract-text-webpack-plugin
module.exports = {"menu":"_234kA","closed":"mzcIB _234kA","open":"_21kVG _234kA","fixed":"_1mv8Z","item":"_1BNHV","headingItem":"_2ulV2 _1BNHV","link":"_3VIli","linkWithExtra":"_3PiBD _3VIli","overlay":"_3AjGZ","overlayActive":"B14av _3AjGZ","extra":"f_ztM"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DropMenu.css
// module id = 799
// module chunks = 0